import React from "react";
import { injectIntl, defineMessages } from "react-intl";
import FormFieldLabel from "../appForm/FormFieldLabel";
import PropTypes from "prop-types";
import styled from "styled-components";
import { TextField } from "@onelogin/react-components";

const messages = defineMessages({
  lastModified: {
    id: "lastModified",
    defaultMessage: `Modified {date}`
  },
  created: {
    id: "created",
    defaultMessage: `Created {date}`
  },
  history: {
    id: "history",
    defaultMessage: `History`
  }
});

const StyledTextField = styled(TextField)`
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0px;
  }
`;

export const HistoryField = ({ updatedAt, createdAt, intl }) => {
  return (
    <div>
      {(updatedAt || createdAt) && (
        <FormFieldLabel label={intl.formatMessage(messages.history)} />
      )}
      {updatedAt && (
        <StyledTextField>
          {intl.formatMessage(messages.lastModified, {
            date: intl.formatRelative(updatedAt)
          })}
        </StyledTextField>
      )}
      {createdAt && (
        <StyledTextField>
          {intl.formatMessage(messages.created, {
            date: intl.formatRelative(createdAt)
          })}
        </StyledTextField>
      )}
    </div>
  );
};

HistoryField.propTypes = {
  updatedAt: PropTypes.string,
  createdAt: PropTypes.string
};

export default injectIntl(HistoryField);
